import React from 'react'
import NameInfo from './NameInfo';
import Answer from './Answer';
export default function index({data,answers }) {
    const containerStyle = {
        border: "1px solid #E0E2E6",
        borderRadius: "16px",
        background: "#FFFFFF",
        boxShadow: "0px 4px 16px 0px #1018280F",
        padding: "24px 36px 24px 36px",
        minHeight: "100px",
        marginBottom:'24px'
      };
      // console.log('data box',data);
      // console.log('question val',question)
  return (
    <>
    <div style={containerStyle}>
        <NameInfo data={data}  />
        <Answer data={data}  answers={answers}/>
    </div>
    
    </>
  )
}
